import {
  TrackImpressionDirective,
  TrackInteractionDirective,
} from '@analytics/events';
import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getDropLinkObject, getFieldValue } from '@core/jss-utils';
import {
  getImageSettingsFromRendering,
  ImageComponent,
  RichTextWrapperComponent,
  type ImageSettings,
} from '@legacy/common-ui-utility-components';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

interface FaqItem {
  id: string;
  question: string;
  answer: string;
  isCollapsed: boolean;
  clickData: { subject: string; name: string };
  imageSettings?: ImageSettings;
}

@Component({
  selector: 'wl-offer-faq',
  templateUrl: './offer-faq.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    TrackInteractionDirective,
    NgbAccordionModule,
    RichTextWrapperComponent,
    ImageComponent,
  ],
})
export class OfferFAQComponent {
  readonly rendering = input.required<InnogyComponentRendering>();

  readonly content = computed(() => ({
    title: getFieldValue(this.rendering(), 'title', ''),
    faqItems: this.mapFaqItems(this.rendering().fields?.['faqItems']),
  }));

  private mapFaqItems(faqItems: unknown): FaqItem[] {
    if (!faqItems || !Array.isArray(faqItems)) {
      return [];
    }
    return faqItems.map((item): FaqItem => {
      const question =
        getFieldValue(item, 'AlternativeQuestion', '') ||
        getFieldValue(
          getDropLinkObject(item.fields, 'Question'),
          'Question',
          ''
        );
      return {
        id: item.id,
        question,
        answer: getFieldValue(item, 'Answer', ''),
        isCollapsed: true,
        clickData: {
          subject: 'faq',
          name: question,
        },
        imageSettings: getImageSettingsFromRendering(item),
      };
    });
  }
}
